import React from "react";

import { useNavigate } from "react-router-dom";

import "./index.scss";

export default function BackButton() {
  const navigate = useNavigate();
  return (
    <div
      className="b-button"
      onClick={() => {
        navigate(-1);
      }}
    >
      <span>
        <img src="/assets/icons/left-arrow.svg" alt="arrow" />
      </span>
      <span>Back</span>
    </div>
  );
}
